import React, {useState} from 'react';
import {Bar} from 'react-chartjs-2';
import {Chart as ChartJS, CategoryScale, BarElement, Title, Tooltip, Legend} from 'chart.js';
import {Box, HStack, useBreakpointValue} from "@chakra-ui/react";
import {StyledButton} from "../../index";

ChartJS.register(CategoryScale, BarElement, Title, Tooltip, Legend);

export const BarChartWithFilters = () => {
    const [timeRange, setTimeRange] = useState('1day');
    const isMobile = useBreakpointValue({ base: true, md: false });

    const generateTimeLabels = () => {
        const labels = [];
        const now = new Date();
        for (let i = 0; i <= 8; i++) {
            const time = new Date(now.getTime() - i * 2 * 60 * 60 * 1000);
            const hours = time.getHours().toString().padStart(2, '0');
            const minutes = time.getMinutes().toString().padStart(2, '00');
            const label = `${hours}:${minutes}`;

            if (i === 0) {
                labels.unshift('now');
            } else {
                labels.unshift(label);
            }
        }
        return labels;
    };


    const getDataForRange = (range) => {
        switch (range) {
            case '1day':
                return {
                    labels: generateTimeLabels(),
                    datasets: [
                        {
                            data: [20, 40, 60, 80, 100, 120, 140, 160,180,],
                            backgroundColor: '#5834A8',
                            barThickness: isMobile ? 15 : 20,
                        },
                    ],
                    // timesLabel: 'Hours',
                };
            case '7days':
                return {
                    labels: ['1', '2', '3', '4', '5', '6', '7'],
                    datasets: [
                        {
                            data: [12, 15, 13, 10, 17, 14, 13],
                            backgroundColor: '#5834A8',
                            barThickness: isMobile ? 15 : 20,
                        },
                    ],
                };
            case '1week':
                return {
                    labels: ['Week 1', 'Week 2', 'Week 3', 'Week 4'],
                    datasets: [
                        {
                            data: [30, 40, 35, 45],
                            backgroundColor: '#5834A8',
                            barThickness: isMobile ? 15 : 20,
                        },
                    ],
                };
            case '3weeks':
                return {
                    labels: ['Week 1', 'Week 2', 'Week 3'],
                    datasets: [
                        {
                            data: [32, 42, 36],
                            backgroundColor: '#5834A8',
                            barThickness: isMobile ? 15 : 20,
                        },
                    ],
                };
            default:
                return {
                    labels: ['1'],
                    datasets: [
                        {
                            data: [12],
                            backgroundColor: '#5834A8',
                            barThickness: isMobile ? 15 : 20,
                        },
                    ],
                };
        }
    };

    const {labels, datasets, timesLabel} = getDataForRange(timeRange);

    const optionsBar = {
        indexAxis: isMobile ? 'y' : 'x',
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false,
            },
            title: {
                display: true,
            },
        },
        scales: {
            x: {
                title: {
                    display: true,
                    text: timesLabel,
                },
                ticks: {
                    padding: 10,
                },
            },
            y: {
                beginAtZero: true,
            },
        },
    };

    return (
        <Box
            position={'relative'}
            width="99%"
            height={{ base: "300px", md: "400px", lg: '400px' }}
            maxWidth="100%">
            <HStack
                gap={'16px'}>
                <StyledButton
                    fontWeight={'400'}
                    bg={'neutral.900'}
                    fontSize={'body.sm'}
                    w={'42px'}
                    h={'32px'}
                    onClick={() => setTimeRange('1day')}>
                    1D
                </StyledButton>
                <StyledButton
                    fontWeight={'400'}
                    bg={'neutral.900'}
                    fontSize={'body.sm'}
                    w={'42px'}
                    h={'32px'}
                    onClick={() => setTimeRange('7days')}>
                    7D
                </StyledButton>
                <StyledButton
                    fontWeight={'400'}
                    bg={'neutral.900'}
                    fontSize={'body.sm'}
                    w={'42px'}
                    h={'32px'}
                    onClick={() => setTimeRange('1week')}>
                    1W
                </StyledButton>
                <StyledButton
                    fontWeight={'400'}
                    fontSize={'body.sm'}
                    bg={'neutral.900'}
                    w={'42px'}
                    h={'32px'}
                    onClick={() => setTimeRange('3weeks')}>
                    3M
                </StyledButton>
            </HStack>
            <Bar options={optionsBar} data={{labels, datasets}}/>
        </Box>
    );
};

